import QRCode from 'qrcode'

export const QR_DEFAULTS = {
    title: 'Vamos conversar no WhatsApp?',
    subtitle: 'Aponte a câmera e fale com a nossa equipe',
    color: '#635BFF',
}
export const QR_COLORS = [
    { label: 'Roxo', value: '#635BFF' },
    { label: 'Verde', value: '#168653' },
    { label: 'Azul', value: '#2563EB' },
    { label: 'Rosa', value: '#DB2777' },
]
export const QR_SIZE = 1600

export function whatsappLink(phone) {
    const value = String(phone || '').trim()
    if (!/^[+\d\s().-]+$/.test(value)) return ''
    const digits = value.replace(/\D/g, '')
    return /^[1-9]\d{7,14}$/.test(digits) ? `https://wa.me/${digits}` : ''
}

function roundedRect(ctx, x, y, width, height, radius, color) {
    ctx.fillStyle = color
    ctx.beginPath()
    ctx.moveTo(x + radius, y)
    ctx.arcTo(x + width, y, x + width, y + height, radius)
    ctx.arcTo(x + width, y + height, x, y + height, radius)
    ctx.arcTo(x, y + height, x, y, radius)
    ctx.arcTo(x, y, x + width, y, radius)
    ctx.fill()
}

function centeredText(ctx, text, y, size, weight, color) {
    let fontSize = size
    ctx.font = `${weight} ${fontSize}px Arial, sans-serif`
    while (ctx.measureText(text).width > 1200 && fontSize > 16) {
        ctx.font = `${weight} ${--fontSize}px Arial, sans-serif`
    }
    ctx.fillStyle = color
    ctx.textAlign = 'center'
    ctx.fillText(text, QR_SIZE / 2, y)
}

// Preview and download use the same pixels. QR modules remain square and have
// a four-module white quiet zone, including in the decorated card.
export function renderWhatsAppQRCode({ phone, model, title, subtitle, color = QR_DEFAULTS.color }) {
    const link = whatsappLink(phone)
    if (!link) throw new Error('Este número não possui um telefone válido com código do país.')
    const canvas = document.createElement('canvas')
    canvas.width = canvas.height = QR_SIZE
    const ctx = canvas.getContext('2d')
    if (!ctx) throw new Error('Seu navegador não conseguiu gerar a imagem. Tente novamente.')
    ctx.fillStyle = '#FFFFFF'
    ctx.fillRect(0, 0, QR_SIZE, QR_SIZE)
    if (model === 'card') {
        ctx.fillStyle = '#F3F4F8'
        ctx.fillRect(0, 0, QR_SIZE, QR_SIZE)
        roundedRect(ctx, 92, 100, 1416, 1416, 64, '#E5E7EF')
        roundedRect(ctx, 92, 82, 1416, 1416, 64, '#FFFFFF')
        roundedRect(ctx, 726, 150, 148, 11, 5, color)
        centeredText(ctx, title.trim(), 275, 68, '700', '#172033')
        centeredText(ctx, subtitle.trim(), 1355, 40, '400', '#525D70')
        roundedRect(ctx, 720, 1427, 160, 6, 3, color)
    }
    const { modules } = QRCode.create(link, { errorCorrectionLevel: 'H' })
    const scale = Math.floor((model === 'card' ? 992 : QR_SIZE) / (modules.size + 8))
    const offset = Math.floor((QR_SIZE - (modules.size + 8) * scale) / 2) + 4 * scale
    ctx.fillStyle = '#172033'
    for (let row = 0; row < modules.size; row++) {
        for (let col = 0; col < modules.size; col++) {
            if (modules.get(row, col)) ctx.fillRect(offset + col * scale, offset + row * scale, scale, scale)
        }
    }
    return canvas
}
